//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[],[[["referenceType","externalFileSpec"],"EstablishReference",{},2,0],[[],"GetFileSpec",{R_:{fileSpec:''}},0,0],[["externalFileDefkey"],"SetExternalFileDefinitionKey",{},1,0],[["doSave"],"SetCandidateForSave",{},1,0],[[],"SetAssociatedFileReference",{},0,0]],[]];
SPLM.ExternalFileReferenceAdapter = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ExternalFileReferenceAdapter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ExternalFileReferenceAdapter.Type = Object.freeze({
    "Native" : "Native", "Part" : "Part", "ImanFile" : "ImanFile", "DatabaseObject" : "DatabaseObject"});

export default SPLM;